import { optionTitle_schedulingResponse } from './ResourceScheduling.locstring.json';
import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
import { ALLOWED_OPTION_KEYS } from './ResourceSchedulingConstants';
import { isFeatureEnabled } from 'owa-feature-flags';

const lazyFullModule = new LazyModule(() => import('./lazySchedulingResponseFullOption'));
const ResourceSchedulingResponse: LazyOption = createLazyOption(
    {
        key: 'resourceSchedulingResponse',
        titleStringKey: optionTitle_schedulingResponse,
        searchTermsStringKey: optionTitle_schedulingResponse,
        isHidden: () => {
            return !isFeatureEnabled('cal-mf-resourceSchedulingSetting');
        },
        allowedOptionKeys: ALLOWED_OPTION_KEYS,
    },
    lazyFullModule,
    m => m.default
);
export default ResourceSchedulingResponse;
